"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deduceStatuses = exports.getIsListingSubmission = exports.getListingSubmissionType = exports.getIsCertificationEligible = exports.getIsNewOffering = exports.getIsPieSyncConnector = exports.getInstallsBucket = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _enviro = _interopRequireDefault(require("enviro"));

var _I18n = _interopRequireDefault(require("I18n"));

var SubmissionTypes = _interopRequireWildcard(require("../constants/submissions/SubmissionTypes"));

var _Listings = require("../constants/Listings");

var MAX_INSTALLS_BUCKET = 10000;
var NEW_LISTING_DAYS = 30;
var MIN_INSTALLS_TO_CERTIFY = 3;
var CERTIFICATION_MONTHS = 6;
var PIESYNC_QA_OFFERING_ID = 737;
var PIESYNC_QA_NATIVE_ID = '1175334';
var PIESYNC_PROD_OFFERING_ID = 161;
var PIESYNC_PROD_NATIVE_ID = '32450';

var getValueFactor = function getValueFactor(value, factor) {
  return Math.floor(value / factor) * factor;
};

var getInstallsBucket = function getInstallsBucket(value) {
  if (value < 10) {
    return 0;
  } else if (value < 50) {
    return getValueFactor(value, 10);
  } else if (value < 100) {
    return getValueFactor(value, 50);
  } else if (value < 500) {
    return getValueFactor(value, 100);
  } else if (value < MAX_INSTALLS_BUCKET) {
    return getValueFactor(value, 500);
  }

  return MAX_INSTALLS_BUCKET;
};

exports.getInstallsBucket = getInstallsBucket;

var getIsPieSyncConnector = function getIsPieSyncConnector(nativeId, offeringId) {
  var _ref = _enviro.default.isQa() ? [PIESYNC_QA_NATIVE_ID, PIESYNC_QA_OFFERING_ID] : [PIESYNC_PROD_NATIVE_ID, PIESYNC_PROD_OFFERING_ID],
      _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      pieSyncNativeId = _ref2[0],
      pieSyncOfferingId = _ref2[1];

  if (typeof nativeId === 'number') {
    nativeId = "" + nativeId;
  }

  return nativeId === pieSyncNativeId && offeringId !== pieSyncOfferingId;
};

exports.getIsPieSyncConnector = getIsPieSyncConnector;

var getIsNewOffering = function getIsNewOffering(firstPublishedAt) {
  var diffInDays = _I18n.default.moment().diff(_I18n.default.moment(firstPublishedAt), 'days');

  return diffInDays < NEW_LISTING_DAYS;
};

exports.getIsNewOffering = getIsNewOffering;

var getIsCertificationEligible = function getIsCertificationEligible(installs, firstPublishedAt) {
  return installs >= MIN_INSTALLS_TO_CERTIFY && _I18n.default.moment().diff(_I18n.default.moment(firstPublishedAt), 'months') >= CERTIFICATION_MONTHS;
};

exports.getIsCertificationEligible = getIsCertificationEligible;

var getListingSubmissionType = function getListingSubmissionType(offering) {
  if (offering.get('publishedListing')) {
    return SubmissionTypes.UPDATE_LISTING;
  }

  return SubmissionTypes.NEW_LISTING;
};

exports.getListingSubmissionType = getListingSubmissionType;

var getIsListingSubmission = function getIsListingSubmission(submissionType) {
  return [SubmissionTypes.NEW_LISTING, SubmissionTypes.UPDATE_LISTING].includes(submissionType);
};

exports.getIsListingSubmission = getIsListingSubmission;

var deduceStatuses = function deduceStatuses(offering) {
  var statuses = [];

  if (offering.publishedListing) {
    if (offering.lastCertifiedAt || offering.certifiedAt) {
      statuses.push(_Listings.ListingStatus.CERTIFIED);
    } else {
      statuses.push(_Listings.ListingStatus.LISTED);
    }
  }

  if (offering.unpublishedListing) {
    if (offering.submissions && offering.submissions.some(function (sub) {
      return getIsListingSubmission(sub.submissionType);
    })) {
      statuses.push(_Listings.ListingStatus.IN_REVIEW);
    } else {
      statuses.push(_Listings.ListingStatus.DRAFT);
    }
  }

  return statuses;
};

exports.deduceStatuses = deduceStatuses;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/utils/offerings.js
// module id = 207
// module chunks = 209 210 211 212